import { render } from "./DbSelection.vue?vue&type=template&id=5532adfa&scoped=true&ts=true"
import script from "./DbSelection.vue?vue&type=script&lang=ts"
export * from "./DbSelection.vue?vue&type=script&lang=ts"

import "./DbSelection.vue?vue&type=style&index=0&id=5532adfa&scoped=true&lang=css"
import "./DbSelection.vue?vue&type=style&index=1&id=5532adfa&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5532adfa"]])

export default __exports__